import React from "react";
import TextInput from "../TextInput";
import classNames from "classnames";
import Button from "../Button";
import debounce from "lodash-es/debounce";
import config from "../../../config/config";

export default class SearchField extends React.Component {

    constructor(props) {
        super(props);
        this.searchDebounce = debounce((search) => {
            if ((search || '').length >= config.minimumLengthOfSearch) {
                this.props.setParams({
                    search,
                    searchtype: this.props.searchtype
                });
            } else {
                this.props.setParams({
                    search: undefined,
                    searchtype: undefined
                });
            }
        }, 300);
        if (((this.props.params || {}).search || '') !== ((this.props.state || {}).search || '')) {
            this.props.setState({search: (this.props.params || {}).search || ''});
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (((this.props.params || {}).search || '') !== ((prevProps.params || {}).search || '')) {
            this.props.setState({search: (this.props.params || {}).search || ''});
        }
    }

    render() {
        const search = (this.props.state || {}).search || '';
        return (
            <div className="search-field">
                <div className={classNames({"input-group": search.length})}>
                    <TextInput
                        label={false}
                        value={search}
                        placeholder="Keresés..."
                        saveChanges={(field, search) => this.props.setState({search}, () => {
                            this.searchDebounce(search);
                        })}
                    />
                    {!!search.length && <span className="input-group-btn">
                        <Button icon={{lib: "fa", name: "times"}} color="default" onClick={() => this.props.setState({search: ''}, () => {
                            this.searchDebounce('');
                        })} />
                    </span>}
                </div>
            </div>
        );
    }
}